import { shopDateTime, bookingStart } from '../../utils/regional';
import React,{useState, useEffect, useRef} from 'react'
import { useNavigate } from 'react-router-dom';
import { inject, observer } from "mobx-react";
import _useTranslate from '../../hooks/_useTranslate';
import GreenSubmitButton from "../../buttons/greenSubmitButton";
import Colors from '../../assets/colors';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DigitalClock  } from '@mui/x-date-pickers/DigitalClock';
import { FormControl, MenuItem , FormHelperText, TextField  } from '@mui/material';
import { DateTime } from "luxon";
import Utils from '../../Utils';
import * as cloneDeep from 'lodash/cloneDeep';

import "./Reservation.css";

const Reservation = ({feathersStore})=> {
  
  let navigate = useNavigate();

  const firstNameElement = useRef();
  const lastNameElement = useRef();
  const phoneElement = useRef();
  const emailElement = useRef();

  let common = _useTranslate(feathersStore.language, "common");  
  let cart = _useTranslate(feathersStore.language, "cart");  

  const personsArray = [2, 3, 4, 5, 6, 7, 8, 9, 10];
  const shopNow = () => DateTime.now().setZone(feathersStore.timezone()).setLocale(feathersStore.displayLocale());
  const today = shopNow().startOf("day");

  const roundHour = () => {
    let dt = DateTime.now().setZone(feathersStore.timezone())
    let roundedDate = dt;
    if(dt.minute < 30)roundedDate = dt.set({minute: 30}).startOf("minute");
    else roundedDate = dt.plus({ hours: 1}).startOf("hour");
    return roundedDate.plus({ hours: 1});  //add at least 1 hour before booking;
  }

  const [bookingDone, setBookingDone] = useState(false);
  const [email, setEmail] = useState(feathersStore.user?.email  || "");
  const [firstName, setFirstName] = useState(feathersStore.user?.firstname || ""); 
  const [lastName, setLastName] = useState(feathersStore.user?.lastname || ""); 
  const [phone, setPhone] = useState(feathersStore.user?.phone || ""); 
  const [bookingComment, setBookingComment] = useState("");
  const [firstNameError, setFirstNameError] = useState(false); 
  const [lastNameError, setLastNameError] = useState(false); 
  const [phoneError, setPhoneError] = useState(false); 
  const [bookingPersons, setBookingPersons] = useState(2);
  const [bookingDate, setBookingDate] = useState(today);
  const [bookingHour, setBookingHour] = useState(roundHour()); 
  const [tables, setTables] = useState([]);
  const weekdaysArray =  ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
  const extendedWeekdaysArray =  ["extendedMonday", "extendedTuesday", "extendedWednesday", "extendedThursday", "extendedFriday", "extendedSaturday", "extendedSunday"]
 
  useEffect(() => {
    setBookingPersons(2);
    setBookingDate(shopNow().startOf("day"));
    setBookingHour(roundHour());
  }, [feathersStore?.isAuthenticated, feathersStore.settings?.timezone, feathersStore.settings?.country]);

  useEffect(() => {
    const asyncFn = async() => {
      const _tables = await feathersStore.bookingTables();
      setTables(_tables);
      }
      feathersStore?.isAuthenticated && asyncFn();
  }, [feathersStore?.isAuthenticated, feathersStore.tablePatchedEvent]);

  const shouldDisableTime = (value, view, bookingDate, bookingPersons) => {
    let _bookingDate = cloneDeep(bookingDate);
    const weekday = (bookingDate.weekday + 6) % 7;    
    const luxonDay = feathersStore?.settings?.extendedDay ? extendedWeekdaysArray[weekday] : weekdaysArray[weekday];
    const dayData = feathersStore?.settings[luxonDay];   
    if(dayData){ 

      const openingDt = _bookingDate.set({ hour: +dayData.openingHours.split(':')[0], minute: +dayData.openingHours.split(':')[1], seconds: 0, milliseconds: 0 })
      let closingDt = _bookingDate.set({ hour: +dayData.closingHours.split(':')[0], minute: +dayData.closingHours.split(':')[1], seconds: 0, milliseconds: 0 })
      if(closingDt < openingDt)closingDt = _bookingDate.endOf("day");
      else closingDt = closingDt.minus({hours: 2}); //Two hours booking duration
      const valueDt = _bookingDate.set({ hour: +value.get("hour"), minute: +value.get("minute"), seconds: 0, milliseconds: 0 });    
      
    
      if((bookingDate.toISODate() === shopNow().toISODate())
          && (valueDt < roundHour())){        
        return true;
      }else  if((valueDt < openingDt || valueDt > closingDt) ){
        return true;
      }else if(checkUnAvailableTable(valueDt, bookingPersons)){
       return true;
      }
     
    }  
    return false;
  };

  const checkUnAvailableTable = (valueDt, bookingPersons) => {
    const availableTables = findAvailableTables(valueDt, bookingPersons);
    if(availableTables?.length < 1)return true;
    else return false;
  }

  const findAvailableTables = (valueDt, bookingPersons) => {
    const availableTables = tables
    .filter(table => (table.capacity >= +bookingPersons) && (table.capacity <  (+bookingPersons + 3))) // Do not book enormously big table
    .filter(t => {
      if(!t?.bookings || t.bookings.length < 1)return true;
      //available only if NO existing booking overlaps the requested 2h slot
      return t.bookings.every(booking => {
        const start = bookingStart(booking, feathersStore.timezone());
        return (start.plus({hours: 2}) <= valueDt) || (start >= valueDt.plus({hours: 2}));
      });
    })
    return availableTables;
  }

  const shouldDisableDate = (value) => {
    const weekday = (value.weekday+ 6) % 7;   
    const luxonDay = weekdaysArray[weekday];
    if (feathersStore?.settings[luxonDay]?.hoursEnabled) {
      return true;
    }  
    return false;
  };

  const createBooking = async() => {
    let _bookingDate = cloneDeep(bookingDate);
    const selectedDT = shopDateTime(_bookingDate, bookingHour, feathersStore.timezone());
    const newBooking =  {
      bookingName: firstName + " " + lastName,
      bookingPersons: bookingPersons, 
      bookingPhone: phone,           
      bookingDate: bookingDate.toISO(),            
      bookingHour: bookingHour.toLocaleString(DateTime.TIME_24_SIMPLE),          
      bookingComment: bookingComment || ''  ,
      webBooking: true          
    };
    const availableTables = findAvailableTables(selectedDT, bookingPersons)?.sort((a,b) => a.capacity - b.capacity);
    const tableToBePatched = availableTables?.[0];
    if(!tableToBePatched){
      alert(common.noTableAvailable || "No table is available for the selected time. Please pick another slot.");
      return;
    }
    let newBookings = [...(tableToBePatched.bookings || [])];
    newBookings.push(newBooking);
    const sortedBookings = newBookings.sort((a,b) => bookingStart(a, feathersStore.timezone()).toMillis() - bookingStart(b, feathersStore.timezone()).toMillis())
    let payload = {bookings: sortedBookings, newWebBooking: true};    
    
    try{
      await feathersStore.patchTable(tableToBePatched._id, payload);
      //keep the booking context so the customer can pre-order food for it
      feathersStore.setPreOrderBooking({
        tableId: tableToBePatched._id,
        bookingDay: newBooking.bookingDate.slice(0, 10),
        bookingHour: newBooking.bookingHour,
        bookingPhone: newBooking.bookingPhone,
        bookingName: newBooking.bookingName,
        deferredTime: selectedDT.toISO()
      });
      setBookingDone(true);
    }catch(error){
      console.log(error)
      //the server may now reject conflicting/invalid bookings (slot guard) - tell the customer
      alert(common.bookingFailed || "The booking could not be completed. The selected time may no longer be available - please pick another slot.");
    }
   
   
  } 

  useEffect(() => {
    setEmail(feathersStore.user?.email || "");
    setFirstName(feathersStore.user?.firstname || "");
    setLastName(feathersStore.user?.lastname || "");
    setPhone(feathersStore.user?.phone || "")
  }, [feathersStore.user])
    
  const firstNameChange = event => {    
    setFirstName(event.target.value);
    firstNameValidation(event.target.value);   
  };

  const lastNameChange = event => {    
    setLastName(event.target.value);
    lastNameValidation(event.target.value);   
  };

  const phoneChange = event => {    
    setPhone(event.target.value);
    phoneValidation(event.target.value);   
  };

  const emailChange = event => {    
    setEmail(event.target.value);
  };

  const bookingCommentChange = event => {    
    setBookingComment(event.target.value);
  };

  const firstNameValidation = val => {
    if (!Utils.validateName(val) ) {
      setFirstNameError(true);
    }else{
     setFirstNameError(false);
   }
  }

  const lastNameValidation = val => {
    if (!Utils.validateName(val) ) {
      setLastNameError(true);
    }else{
     setLastNameError(false);
   }
  }

  const phoneValidation = val => {
    if (!Utils.validatePhone(val, feathersStore.isGreekFiscal()) ) {
      setPhoneError(true);
    }else{
     setPhoneError(false);
   }
  } 

  const enterFirstNamePressed = (ev) => {   
    if (ev.key === 'Enter') {
        lastNameElement.focus();
    }
  }

  const enterLastNamePressed = (ev) => {   
    if (ev.key === 'Enter') {
      phoneElement.focus();
    }
  }  

  const enterPhonePressed = (ev) => {   
    if (ev.key === 'Enter') {
      firstNameElement.focus();
    }
  }

  const enterEmailPressed = (ev) => {   
    if (ev.key === 'Enter') {
      firstNameElement.focus();
    }
  }  
  
  const goToHome = () => {
    feathersStore.setPreOrderBooking(null); //customer declined to pre-order
    navigate('/');
  }

  const orderForBooking = () => {
    //enter table mode on the booked table: catalog/prices switch to restaurant (enabled, retail);
    //checkout will attach the order to the booking (preOrderBooking is set) instead of the table
    const tableId = feathersStore.preOrderBooking?.tableId;
    if(!tableId) return;
    try{
      //table mode lives as long as the pre-order session: until the booking hour
      const bookingMs = new Date(feathersStore.preOrderBooking?.deferredTime).getTime();
      const expiry = Number.isFinite(bookingMs) ? bookingMs : new Date().getTime() + 6 * 60 * 60 * 1000;
      localStorage.setItem('tableId', JSON.stringify({value: tableId, expiry}));
    }catch(e){}
    feathersStore.setTableId(tableId);
    navigate('/');
  }

  return(
  <> 
    <div className="body-container">
       <div className="grey-header">{common.reserveTable}</div>
      <div className="reservation-container">     
        <div className="reservation-body">
          <div className="reservation-section-header">{common.chooseHour}<div className="reservation-section-line"></div></div>
          <div className="reservation-select-row">
            <TextField
              select
              label={common.party}
              variant="outlined" 
              type="number" 
              defaultValue={2}
              InputProps={{ inputProps: { min: "2", max: "10", step: "1" } }}
              id="my-input" 
              value={+bookingPersons}
              onChange={(event) => setBookingPersons(+event.target.value)}
            >   
              {personsArray.map((person) => (
                <MenuItem key={person} value={+person}>
                  {person}
                </MenuItem>
              ))}
            </TextField>        
            <div className="reservation-second-input">             
              <DatePicker
                timezone={feathersStore.timezone()}
                label={common.pickDate}
                minDate={today}
                maxDate={today.plus({ days: 15 })}
                value={bookingDate}
                onChange={(newValue) => setBookingDate(newValue)}
                shouldDisableDate={shouldDisableDate}
              />              
            </div>     
            <div className="reservation-second-input">             
              <DigitalClock
                timezone={feathersStore.timezone()}
                label={common.chooseHour}
                ampm={false}
                minTime={bookingDate}
                value={bookingHour}
                onChange={(newValue) => setBookingHour(newValue)}
                shouldDisableTime={(value, view) => shouldDisableTime(value, view, bookingDate, bookingPersons)}
              />              
            </div>         
          </div>      
          <div className="reservation-table-footer"> 
            <div className="reservation-select-row">
              <FormControl > 
                <TextField
                  label={common.firstName + "*"}
                  variant="outlined" 
                  value={firstName}
                  error={firstNameError}
                  ref={firstNameElement}
                  onChange={firstNameChange}
                  onKeyPress={enterFirstNamePressed}
                />   
                {firstNameError && <FormHelperText id="component-error-text" >{common.firstNameError}</FormHelperText>}
              </FormControl>
              <div className="reservation-second-input">             
                <FormControl > 
                  <TextField
                    label={common.lastName + "*"}
                    variant="outlined" 
                    value={lastName}
                    error={lastNameError}
                    ref={lastNameElement}
                    onChange={lastNameChange}
                    onKeyPress={enterLastNamePressed}
                  />   
                  {lastNameError && <FormHelperText id="component-error-text" >{common.lastNameError}</FormHelperText>}
                </FormControl>            
              </div>   
            </div>
            <div className="reservation-select-row">
              <FormControl >
                <TextField
                  label={common.phone + "*"} 
                  variant="outlined" 
                  value={phone}     
                  error={phoneError}
                  ref={phoneElement}
                  onChange={phoneChange}              
                  onKeyPress={enterPhonePressed}  
                /> 
                {phoneError && <FormHelperText id="component-error-text" >{common.phoneError}</FormHelperText>}
              </FormControl>  
              <div className="reservation-second-input">             
                <TextField               
                  label={common.email} 
                  variant="outlined" 
                  value={email} 
                  onKeyPress={enterEmailPressed}
                  onChange={emailChange}
                />                
              </div> 
            </div>      
            <div className="reservation-select-row">
              <TextField 
                sx={{width: "100%"}}
                label={common.bookingComment}
                variant="outlined"
                multiline
                rows={4} 
                value={bookingComment}  
                onKeyPress={enterEmailPressed}
                onChange={bookingCommentChange}
              />   
            </div>     
          </div> 
        </div> 
        <div className="reservation-total-table">
          <div className="section-header">{common.yourReservation}<div className="section-line"></div></div>        
          <div className="reservation-total-body">
            <div className="reservation-totals-line">{common.party}: {bookingPersons}</div>
            <div className="reservation-totals-line">{common.date}: {bookingDate.setLocale(feathersStore.displayLocale()).toLocaleString(DateTime.DATE_SHORT)}</div>
            <div className="reservation-totals-line">{common.hour}: {bookingHour.toLocaleString(DateTime.TIME_24_SIMPLE)}</div>
          </div>
          <div className="reservation-total-footer">
            {!bookingDone ?
            <>
            <GreenSubmitButton aria-labelledby='Make reservation'
              disabled={!feathersStore.restaurantOpen || !firstName || !lastName || !phone || !bookingDate || !bookingHour}
              color={undefined}
              title={common.reserveTableUC}
              onClick={createBooking}
              width="100%"
            ></GreenSubmitButton>
            <GreenSubmitButton aria-labelledby='Complete order'
              color={undefined}
              title={cart.continueShopping}
              onClick={goToHome}
              width="100%"
              variant="outlined"
            ></GreenSubmitButton>
            </>
            :
            <>
            <div className="reservation-totals-line" style={{fontWeight: 'bold', marginBottom: 8}}>
              {common.bookingSuccess || "Your table is booked!"}
            </div>
            <GreenSubmitButton aria-labelledby='Order for your reservation'
              color={undefined}
              title={common.orderForBookingUC || "ORDER FOOD FOR YOUR RESERVATION"}
              onClick={orderForBooking}
              width="100%"
            ></GreenSubmitButton>
            <GreenSubmitButton aria-labelledby='Continue'
              color={undefined}
              title={cart.continueShopping}
              onClick={goToHome}
              width="100%"
              variant="outlined"
            ></GreenSubmitButton>
            </>
            }
          </div>
        </div>   
      </div>   
    </div>   
  </>
  )
}

export default inject('feathersStore')(observer(Reservation));